export const HTTPS_ASSINATURA_DIGITAL_MESSAGE =
  'É necessário utilizar uma conexão segura com HTTPS para poder utilizar a assinatura digital.'

export interface ConfiguracaoAssinaturaDigitalModel {
  usuario: string
  senha: string
}
